import React from 'react';

const PointsDisplay = ({
  points = 3599,
  casosCompletados = 25,
  casosParaSiguienteNivel = 30,
  activeTab = 'puntos',
  onTabChange = () => {},
}) => {
  return (
    <div className="bg-white rounded-lg p-4">
      {/* Toggle Buttons - Single Line */}
      <div className="flex mb-6">
        <button
          onClick={() => onTabChange('puntos')}
          className={`py-2 px-4 text-sm font-medium rounded-l-lg transition-colors ${
            activeTab === 'puntos' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
          }`}
        >
          Tus Puntos IUSTIA
        </button>
        <button
          onClick={() => onTabChange('genera')}
          className={`py-2 px-4 text-sm font-medium rounded-r-lg transition-colors ${
            activeTab === 'genera' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
          }`}
        >
          Genera Puntos Iustia
        </button>
      </div>

      {/* Points Display */}
      <div className="text-center py-4">
        <div className="text-4xl font-regular text-gray-900 mb-2">{points.toLocaleString()}</div>
        <div className="text-sm text-gray-600">
          Puntos <span className="font-semibold text-blue-600">iustia</span>
        </div>
      </div>

      {/* Progress Bar with Icon */}
      <div className="mb-6 relative w-4/5 mx-auto">
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4 relative">
          <div
            className="bg-blue-600 h-2 rounded-full transition-all duration-300"
            style={{ width: '45%' }}
          />
          {/* Progress Icon */}
          <div
            className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 bg-blue-600 rounded-full border-2 border-white shadow-sm"
            style={{ left: '45%', marginLeft: '-8px' }}
          >
            <div className="w-full h-full bg-blue-600 rounded-full flex items-center justify-center">
              <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Status Information */}
      <div className="text-left w-4/5 mx-auto">
        <div className="text-xl font-bold text-gray-900 mb-1">{casosCompletados}</div>
        <div className="text-sm text-gray-600">
          Casos Completados | {casosParaSiguienteNivel} casos más para subir de Status
        </div>
      </div>
    </div>
  );
};

export default PointsDisplay;
